import { graphql } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../components/Header';

const ContactStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 9fr;

  gap: 2rem;
  margin-bottom: 1rem;
  margin-top: 2rem;

  span {
    display: block;
  }

  a {
    color: var(--black);
    text-decoration: none;
    transition: all 0.1s ease;
  }

  a:hover {
    color: var(--pop);
  }
`;

const ContactPage = ({ data }) => {
  const contactInfo = data.allSanityHomePageSettings.nodes[0].contactInfo;

  return (
    <>
      <Header />
      <main>
        <title>Contact Page</title>
        <h1>Contact Me</h1>
        <div>
          <ContactStyles>
            <span>Email</span>
            <span>
              <a href={`mailto:${contactInfo.email}?body=Hi+Clay%2C+`}>
                {contactInfo.email}
              </a>
            </span>
          </ContactStyles>
          <ContactStyles>
            <span>Phone</span>
            <span>{contactInfo.phone}</span>
          </ContactStyles>
          <ContactStyles>
            <span>Address</span>
            <div>
              <span>{contactInfo.address.recipient}</span>
              <span>{contactInfo.address.building}</span>
              <span>{contactInfo.address.street}</span>
              <span>
                {contactInfo.address.city}, {contactInfo.address.state}{' '}
                {contactInfo.address.zip}
              </span>
            </div>
          </ContactStyles>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ContactPage;

export const query = graphql`
  {
    allSanityHomePageSettings {
      nodes {
        contactInfo {
          phone
          email
          address {
            building
            city
            recipient
            state
            street
            zip
          }
        }
      }
    }
  }
`;
